import React, { useEffect, useState } from 'react';
// import './patientList.css'
import {
    Badge,
    Button,
    ButtonGroup,
    Card,
    Container,
    Form,
    Image,
    Modal,
    Stack,
    Table,
} from 'react-bootstrap';
import edit from '../../Assets/Img/edit.png';
import view from '../../Assets/Img/eye.png';
import NoDraft from '../../Assets/Img/noDrafts.png';
import { useSelector } from 'react-redux';

import { useNavigate } from 'react-router';
import LoadingComponent from '../LoadingComponent';
import { Eye, Pencil, Plus, Trash2 } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { frenchFormatDate } from '../../helper';
// import AddOptician from './addOptician';
import DeleteUser from '../Profile/deleteUser';
import { usePosListMutation } from './posApi';
import AddPos from './addPos';
import { setSecureItem,getSecureItem,removeSecureItem } from "../../utils/secureStorage";
const PosList = () => {
    const navigate = useNavigate();
    const { t } = useTranslation();
    const user = getSecureItem('UserData');
    const [loading, setLoading] = useState(true);
    const [edit, setEdit] = useState({});
    const config = { email: '', mobile: '' };
    //const [posConfig, setPosConfig] = useState(config);
    const [posConfig, setPosConfig] = useState(() => 
        {
            const saved = getSecureItem("posListConfigCopy") || config;
            return saved ? saved : config;
        });

    const [opticianData, setOpticianData] = useState([]);
    const [posList] = usePosListMutation();

    useEffect(() => {
        if (loading) {
            (async () => {
                let { data } = await posList(posConfig);
                console.log(data, 'datadata');
                setOpticianData(data);
                setLoading(false);
            })();
        }
    }, [loading]);

    const handleFilterChange = (count = 1) => {
        // setPageCount(count);
        setSecureItem("posListConfigCopy", posConfig);
        setPosConfig({ ...posConfig, pageNumber: count });
        setLoading(true);
    }

    const handleChange = (e) => {
        const {name, value} = e.target;
        
        setPosConfig((prevValues) => {
            return {
                ...prevValues,
                email: value,
                mobile: value,
            }
        });
    }

    if (loading) {
        return <LoadingComponent />;
    }

    return (
        <>
            <Container fluid className="list_wrapper">
                <Stack direction="horizontal" gap={3} className="mb-3">
                    <div className="ms-auto">
                        {/* <Button variant='light' onClick={() => { setEditData({}); setShow(true) }}><Plus width={14} height={14} />{t("addPatient")}</Button> */}
                        <AddPos
                            setLoading={setLoading}
                            edit={edit}
                            setEdit={setEdit}
                        />
                    </div>
                </Stack>
                <Card>
                    <Card.Header>
                        <Stack direction="horizontal" gap={3} className='listing_filters'>
                            <Stack direction="horizontal" gap={3}>
                                <Form.Control type='text' onChange={handleChange} value={posConfig.search} name='search' placeholder={t("search")} />
                                {/* <Form.Control type='date' onChange={handleChange} name='startDate' />
                                <Form.Control type='date' onChange={handleChange} name='endDate' /> */}
                                <Button variant='secondary' onClick={() => handleFilterChange()}>{t("search")}</Button>
                            </Stack>
                            <div className="ms-auto">
                                <Button variant='link' className='' onClick={() => {
                                    removeSecureItem("posListConfigCopy");
                                    setPosConfig(config)
                                    setLoading(true)
                                }}>
                                    {t("resetFilters")}
                                </Button>
                            </div>
                        </Stack>
                    </Card.Header>
                    <Card.Body className="table_outer">
                        <Table>
                            <thead>
                                <tr>
                                    <th></th>
                                    <th>{t('name')}</th>
                                    <th>{t('posEmail')}</th>
                                    <th>{t('phone')}</th>
                                    <th>{t('createdOn')}</th>
                                    <th>{t('status')}</th>
                                    <th className="text-center">
                                        {t('actions')}
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {opticianData.length > 0 ? (
                                    opticianData.map((item, index) => (
                                        <tr key={index}>
                                            <td>
                                                <img
                                                    src={
                                                        opticianData.profileImagePath ||
                                                        '/avatar-s-11.jpg'
                                                    }
                                                    alt="profile image"
                                                    style={{
                                                        height: '1.6rem',
                                                        width: '1.6rem',
                                                        borderRadius: '100%',
                                                        outline:
                                                            '1px solid #e9e9e9',
                                                        outlineOffset: '0.2rem',
                                                    }}
                                                />
                                            </td>
                                            <td>
                                                {item?.name} {item?.lastName}
                                            </td>
                                            <td>{item.email}</td>
                                            <td>{item.mobile}</td>
                                            <td>
                                                {frenchFormatDate(
                                                    item.createdDate
                                                )}
                                            </td>
                                            <td>
                                                {' '}
                                                <Badge className="status_badge">
                                                    Active
                                                </Badge>
                                            </td>
                                            <td>
                                                <Stack
                                                    direction="horizontal"
                                                    gap={1}
                                                >
                                                    <div className="m-auto">
                                                        <ButtonGroup>
                                                            <Button
                                                                variant="light"
                                                                onClick={() =>
                                                                    navigate(
                                                                        '/pos/view',
                                                                        {
                                                                            state: {
                                                                                userData:
                                                                                    item,
                                                                            },
                                                                        }
                                                                    )
                                                                }
                                                            >
                                                                <Stack
                                                                    direction="horizontal"
                                                                    gap={1}
                                                                >
                                                                    <Eye
                                                                        width={
                                                                            16
                                                                        }
                                                                    />
                                                                </Stack>
                                                            </Button>
                                                            <Button variant="light">
                                                                <Stack
                                                                    direction="horizontal"
                                                                    gap={1}
                                                                    onClick={() =>
                                                                        setEdit(
                                                                            item
                                                                        )
                                                                    }
                                                                >
                                                                    <Pencil
                                                                        width={
                                                                            16
                                                                        }
                                                                    />
                                                                </Stack>
                                                            </Button>
                                                            {['ADMIN'].includes(
                                                                user?.userType
                                                            ) && (
                                                                <DeleteUser
                                                                    email={
                                                                        item.email
                                                                    }
                                                                    setLoading={
                                                                        setLoading
                                                                    }
                                                                />
                                                            )}
                                                        </ButtonGroup>
                                                    </div>
                                                </Stack>
                                            </td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan={6}>
                                            <Stack
                                                gap={2}
                                                className="mt-5 mb-5 mx-auto text-center"
                                            >
                                                <Image
                                                    src={NoDraft}
                                                    width={88}
                                                    className="mx-auto"
                                                />
                                                <h4>{t('noDataAvailable')}</h4>
                                                <p>
                                                    {t("youHaven'tCreatedAny")}
                                                </p>
                                            </Stack>
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </Card.Body>
                    {/* <Card.Footer>
                        <Stack direction="horizontal" gap={3}>
                            <div className="ms-auto">
                                <Stack direction="horizontal" gap={2}>
                                    <span>{pageCount} of {Math.ceil(patientData?.listData?.userProfileData?.length < patientListConfig.pageSize ? patientData?.listData?.userProfileData?.length : patientData.listData.totalItems / patientListConfig.pageSize)}</span>
                                    <Button variant='secondary' className='paginationBar_rightSide_prev' disabled={pageCount > 1 ? false : true} onClick={() => {
                                        handleFilterChange(pageCount - 1)
                                    }}>{t("prev")}</Button>
                                    <Button className='paginationBar_rightSide_next' disabled={pageCount !== Math.ceil(patientData.listData.totalItems / 50) ? false : true} onClick={() => {
                                        handleFilterChange(pageCount + 1)
                                    }}>{t("next")}</Button>
                                </Stack>
                            </div>
                        </Stack>
                    </Card.Footer> */}
                </Card>
            </Container>
        </>
    );
};

export default PosList;
